import {
    useContext,
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type ICollapsibleTriggerProps from "./type";
import type {
    CollapsibleTriggerWebPropsType
} from "./type";
import {
    getCollapsibleTriggerSize,
    COLLAPSIBLE_TRIGGER_SIZE,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import type {
    CollapsiblePartContentProps
} from "../../type";
import {
    withCollapsibleContext,
    CollapsibleContext
} from "../../context";
import DisclosureChevron from "../../internal/disclosureChevron";
import Button from "../../../button";

const CollapsibleTriggerIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const context = useContext(CollapsibleContext);

    const {
        colors
    } = NCoreUIKitTheme.useContext(context?.customTheme);

    return <DisclosureChevron
        color={customColor ?? colors.content.icon[color]}
        customTheme={context?.customTheme}
        isOpen={context?.isOpen ?? false}
        size={size}
    />;
};

const CollapsibleTriggerContent: FC<CollapsiblePartContentProps<ICollapsibleTriggerProps>> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    openTitle,
    context,
    style,
    title,
    ...props
}) => {
    const customLocalize = customLocalizeProp ?? context.customLocalize;

    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const currentSize = getCollapsibleTriggerSize({
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        currentSize
    });

    const webProps: CollapsibleTriggerWebPropsType = Platform.OS === "web" ? {
        "aria-controls": context.contentID
    } : {};

    const currentTitle = context.isOpen ? openTitle ?? title ?? localize("hide") : title ?? localize("show");

    return <Button
        {...props}
        {...webProps}
        size={COLLAPSIBLE_TRIGGER_SIZE}
        isDisabled={context.isDisabled}
        onPress={context.handleToggle}
        aria-expanded={context.isOpen}
        icon={CollapsibleTriggerIcon}
        style={[
            style,
            containerDynamicStyle
        ]}
        customTheme={customTheme}
        title={currentTitle}
        iconDirection="end"
        variant="ghost"
        type="neutral"
    />;
};
export default withCollapsibleContext("trigger", CollapsibleTriggerContent);
